(function (root) {
  var GROUP_MAX = 20;

  function groupOf(item) {
    var g = item && item.properties && item.properties._gruppe;
    return g ? String(g) : null;
  }

  function groupUpdates(items, key, newQuantity) {
    var line = (items || []).filter(function (i) { return i.key === key; })[0];
    if (!line) return {};
    var qty = Math.max(0, Math.floor(Number(newQuantity)) || 0);
    var group = groupOf(line);
    var out = {};
    if (!group) { out[key] = qty; return out; }
    qty = Math.min(qty, GROUP_MAX);
    items.forEach(function (i) { if (groupOf(i) === group) out[i.key] = qty; });
    return out;
  }

  function groupCartItems(items) {
    var list = items || [];
    var byGroup = {};
    list.forEach(function (i) {
      var g = groupOf(i);
      if (g) (byGroup[g] = byGroup[g] || []).push(i);
    });
    var out = [];
    var done = {};
    list.forEach(function (i) {
      var g = groupOf(i);
      if (!g) { out.push({ type: 'single', item: i }); return; }
      if (done[g]) return;
      done[g] = true;
      var rows = byGroup[g];
      var code = '';
      rows.forEach(function (r) { if (!code && r.properties && r.properties.Konfiguration) code = String(r.properties.Konfiguration); });
      var entry = { type: 'group', id: g, code: code, items: rows, quantity: rows[0].quantity };
      if (rows.some(function (r) { return r.quantity !== rows[0].quantity; })) entry.mixedQuantity = true;
      out.push(entry);
    });
    return out;
  }

  function plainItem(i, name) {
    return { name: name, sku: i.sku || '', quantity: i.quantity, price: i.final_price };
  }

  function quoteItemsFromCart(cartItems) {
    var list = cartItems || [];
    var groups = {};
    list.forEach(function (i) {
      var g = groupOf(i);
      if (g) (groups[g] = groups[g] || []).push(i);
    });
    var out = [];
    var done = {};
    list.forEach(function (i) {
      var g = groupOf(i);
      var code = g && i.properties.Konfiguration ? String(i.properties.Konfiguration) : '';
      if (!g || !code) { out.push(plainItem(i, i.product_title)); return; }
      var rows = groups[g];
      var sameQty = rows.every(function (r) { return r.quantity === rows[0].quantity; });
      if (!sameQty) {
        out.push(plainItem(i, i.product_title + ' (' + code + ')'));
        return;
      }
      if (done[g]) return;
      done[g] = true;
      out.push({
        name: 'SimonsVoss Zylinder AX – Konfiguration ' + code,
        sku: code,
        quantity: rows[0].quantity,
        price: rows.reduce(function (sum, r) { return sum + (r.final_price || 0); }, 0),
      });
    });
    return out;
  }

  var api = { groupOf: groupOf, groupUpdates: groupUpdates, quoteItemsFromCart: quoteItemsFromCart, groupCartItems: groupCartItems, GROUP_MAX: GROUP_MAX };
  root.cartGroups = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
